
import { mapGetters } from 'vuex'
import NoResults from '../NoResults'
import RequestSuccessModal from '../NoResults/RequestSuccessModal'
import RequestMissingProductDialog from '../NoResults/RequestMissingProductDialog'
import ProductCard from '~/components/Catalog/ProductCard'
import ui from '~/ZenOne-StoryBook/mixins/ui.js'
export default {
  name: 'ProductList',
  components: {
    NoResults,
    ProductCard,
    RequestSuccessModal,
    RequestMissingProductDialog,
  },
  mixins: [ui],
  props: {
    showNoResults: {
      type: Boolean,
      default: false,
    },
    products: {
      type: Object,
      default: () => {},
      required: true,
    },
    viewportWidth: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters({
      isFetching: 'catalog/isFetching',
    }),
  },
  methods: {
    onDialogOpen() {
      const dialogOpen = this?.$refs?.dialog?.open
      if (!dialogOpen) return false
      dialogOpen()
    },
    showSuccessModal() {
      const successModalOpen = this?.$refs?.successModal?.open
      if (!successModalOpen) return false
      successModalOpen()
    },
    productCardFilterClickHandler(data) {
      this.$emit('productCardFilterClickHandler', data)
    },
    onAddProductToCart(data) {
      this.$emit('onAddProductToCart', data)
    },
    onChangeQtyInCart(data = {}) {
      this.$emit('onChangeQtyInCart', data)
    },
    onShowAddToInventoryDialog(data = {}) {
      this.$emit('on-show-add-to-inventory-dialog', data)
    },
    onAddToRootFolder(data = {}) {
      this.$emit('on-add-to-root-folder', data)
    },
  },
}
